import * as communities from '../../communityConfigs'
import { map, values } from 'lodash'

function getCommunitySubdomains() {
  return map(values(communities), 'subdomain')
}

export default getCommunitySubdomains
